import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { ODataService } from 'common-services'

export interface IPayerMedia extends IModelBase {
  PayerId: number
  Filename: string
  IsDeleted: boolean
  CreatedOnDateTime: Date
  LastModifiedOnDateTime: Date
  SystemFileName: string
  FileExtensionId: number
}

@Injectable()
export class PayerMediaODataService extends ODataService<IPayerMedia> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'PayerMedias'
  }
}
